/**
 * This file is autogenerated DO NOT EDIT MANUALLY.
 */
import createOpenApiFetchClient, {} from "openapi-fetch";
export const createApiClient = createOpenApiFetchClient;
const REGEXP_UNAUTHENTICATED_ROUTES = ["/v1/auth/*"];
export const authMiddleware = ({ getToken, }) => ({
    async onRequest({ schemaPath, request }) {
        if (REGEXP_UNAUTHENTICATED_ROUTES.some((r) => new RegExp(r).test(schemaPath))) {
            return undefined; // don't modify request for certain paths
        }
        // for all other paths, set Authorization header as expected
        const token = await getToken();
        // dont set header if token is not defined
        if (!token)
            return undefined;
        request.headers.set("Authorization", `Bearer ${token}`);
        return request;
    },
});
